import React from 'react';
import PropTypes from 'prop-types';

export const Button = ({
  className,
  type,
  label,
  buttonIcon,
  buttonIconPosition,
  disabled,
  ...otherProps }) => {
  return (
    <button
      type={type}
      className={['mz-btn', className].join(' ')}
      disabled={disabled}
      {...otherProps}
    >
      {buttonIcon && buttonIconPosition === 'left' && buttonIcon}
      <span>{label}</span>
      {buttonIcon && buttonIconPosition === 'right' && buttonIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  buttonIcon: PropTypes.object,
  buttonIconPosition: PropTypes.string,
};

Button.defaultProps = {
  type: 'button',
};


export default Button;